export default "__VITE_ASSET__550dedee__"